import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_4 = {
  class: "dialog-footer"
};
const _hoisted_5 = {
  class: "xtdiaog"
};
const _hoisted_6 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center"
  }
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_input = _resolveComponent("vxe-input");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_edit = _resolveComponent("edit");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "bg_white wrap_box lc_rw"
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", {
      class: "l-button",
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handlesave && _ctx.handlesave(...args))
    }, "保存"), _ctx.myuserId == _ctx.leaderUserId ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "l-button",
      onClick: _cache[1] || (_cache[1] = (...args) => _ctx.openKeyshow && _ctx.openKeyshow(...args))
    }, "配置表格")) : _createCommentVNode("", true), _ctx.myuserId == _ctx.leaderUserId ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "l-button",
      onClick: _cache[2] || (_cache[2] = (...args) => _ctx.noticeOrder && _ctx.noticeOrder(...args))
    }, "通知下单")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_vxe_table, {
      border: "",
      resizable: "",
      "show-overflow": "",
      "edit-config": {
        trigger: 'click',
        mode: 'cell'
      },
      "max-height": "700",
      data: _ctx.data.tableData,
      width: "100%"
    }, {
      default: _withCtx(() => [_createVNode(_component_vxe_column, {
        type: "seq",
        title: "序号",
        width: "60",
        align: "left",
        class: "ggdycss"
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.keylist, (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: item.key
        }, [item.value && item.key == 'brand' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 0,
          title: "品牌",
          width: "140",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.brand), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'name' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 1,
          title: "产品名称",
          width: "140",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.name), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'image' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 2,
          title: "产品图片",
          width: "130",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [row.sku.image ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: row.sku.image,
            class: "avatar"
          }, null, 8, _hoisted_2)) : _createCommentVNode("", true)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'spu' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 3,
          title: "产品SPU",
          width: "250",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.spu), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'sku' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 4,
          title: "产品SKU",
          width: "250",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.sku), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'mould_cost' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 5,
          title: "出厂价（TCO成本）",
          width: "130",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.mould_cost), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'params' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 6,
          title: "规格参数",
          width: "130",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.params), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'material' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 7,
          title: "产品材质",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.material), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'protocol' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 8,
          title: "协议",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.protocol), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'rate' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 9,
          title: "速率",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.rate), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'package' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 10,
          title: "包装",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.package), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'safe' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 11,
          title: "安规",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.safe), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'interface' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 12,
          title: "接口(输入)",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.interface), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'other' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 13,
          title: "尺码/数量/长度",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.other), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'color' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 14,
          title: "产品颜色",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.color), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'version' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 15,
          title: "功能/版本",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.version), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'output' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 16,
          title: "输出接口",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.output), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'code69' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 17,
          title: "69码",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.code69), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'material_num' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 18,
          title: "备料数量",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.material_num), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'mould_fare_sj' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 19,
          title: "模具费(塑胶)",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.mould_fare_sj), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'mould_fare_wj' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 20,
          title: "模具费(五金)",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.mould_fare_wj), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'electron_fare' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 21,
          title: "电子",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.electron_fare), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'structure_fare' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 22,
          title: "结构/本体",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.structure_fare), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'power_fare' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 23,
          title: "电源",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.power_fare), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'line_fare' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 24,
          title: "线材",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.line_fare), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'package_fare' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 25,
          title: "包材",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.package_fare), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'parts_fare' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 26,
          title: "辅料/配件",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.parts_fare), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'other_fare' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 27,
          title: "硬盘/运费/其他/DDR",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.other_fare), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'process_fare' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 28,
          title: "加工费用",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.process_fare), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'auth_test_fare' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 29,
          title: "认证/测试费用",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.auth_test_fare), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'total_cost' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 30,
          title: "总成本(未摊模具)",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.total_cost), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'tco_cost' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 31,
          title: "物料成本价",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.tco_cost), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'tco_rate' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 32,
          title: "TCO毛利率",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.tco_rate + '%'), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'agent_price' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 33,
          title: "代理商价",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.agent_price), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'channel_rate' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 34,
          title: "渠道毛利润率",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.channel_rate + '%'), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'distribution_price' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 35,
          title: "经销价",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.distribution_price), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'distribution_rate' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 36,
          title: "经销商毛利率",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.distribution_rate + '%'), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'retail_price' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 37,
          title: "建议零售价",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.retail_price), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'min_retail_price' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 38,
          title: "最低零售价",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.min_retail_price), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.value && item.key == 'b2c_rate' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 39,
          title: "B2C毛利润率",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sku.b2c_rate + '%'), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.key == 'b2c' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 40,
          title: "国内B2C",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          },
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.b2c), 1)]),
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.b2c,
            "onUpdate:modelValue": $event => row.b2c = $event,
            type: "integer",
            min: "0",
            clearable: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), item.key == 'amazon' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 41,
          title: "亚马逊",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          },
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.amazon), 1)]),
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.amazon,
            "onUpdate:modelValue": $event => row.amazon = $event,
            type: "integer",
            min: "0",
            clearable: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), item.key == 'cs_global_mall' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 42,
          title: "长沙全球商城",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          },
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.cs_global_mall), 1)]),
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.cs_global_mall,
            "onUpdate:modelValue": $event => row.cs_global_mall = $event,
            type: "integer",
            min: "0",
            clearable: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), item.key == 'sz_global_mall' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 43,
          title: "深圳全球商城",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          },
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.sz_global_mall), 1)]),
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.sz_global_mall,
            "onUpdate:modelValue": $event => row.sz_global_mall = $event,
            type: "integer",
            min: "0",
            clearable: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), item.key == 'nation_channels' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 44,
          title: "国内渠道",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          },
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.nation_channels), 1)]),
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.nation_channels,
            "onUpdate:modelValue": $event => row.nation_channels = $event,
            type: "integer",
            min: "0",
            clearable: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), item.key == 'overseas_channels' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 45,
          title: "海外渠道",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          },
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.overseas_channels), 1)]),
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.overseas_channels,
            "onUpdate:modelValue": $event => row.overseas_channels = $event,
            type: "integer",
            min: "0",
            clearable: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), item.key == 'market_depart' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 46,
          title: "市场部",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          },
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.market_depart), 1)]),
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.market_depart,
            "onUpdate:modelValue": $event => row.market_depart = $event,
            type: "integer",
            min: "0",
            clearable: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), item.key == 'f2b211_1688' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 47,
          title: "F2B211/1688",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          },
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.f2b211_1688), 1)]),
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.f2b211_1688,
            "onUpdate:modelValue": $event => row.f2b211_1688 = $event,
            type: "integer",
            min: "0",
            clearable: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), item.key == 'zj' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 48,
          title: "总计",
          width: "120",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(parseInt(parseInt(row.b2c) + parseInt(row.amazon) + parseInt(row.cs_global_mall) + parseInt(row.sz_global_mall) + parseInt(row.nation_channels) + parseInt(row.overseas_channels) + parseInt(row.market_depart) + parseInt(row.f2b211_1688))), 1)]),
          _: 1
        })) : _createCommentVNode("", true), item.key == 'remark' ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 49,
          title: "备注",
          "edit-render": {
            autofocus: '.vxe-input--inner'
          },
          "min-width": "270",
          align: "left"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.remark), 1)]),
          edit: _withCtx(({
            row
          }) => [_createVNode(_component_vxe_input, {
            modelValue: row.remark,
            "onUpdate:modelValue": $event => row.remark = $event,
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true)], 64);
      }), 128))]),
      _: 1
    }, 8, ["data"]), _createVNode(_component_el_dialog, {
      modelValue: _ctx.data.isShowColTable,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.data.isShowColTable = $event),
      "close-on-click-modal": false,
      "destroy-on-close": "",
      "append-to-body": false,
      width: "65%",
      title: "表单字段配置",
      center: ""
    }, {
      footer: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createElementVNode("div", {
        class: "l-button",
        onClick: _cache[7] || (_cache[7] = (...args) => _ctx.makeSurekeys && _ctx.makeSurekeys(...args)),
        style: {
          "float": "right"
        }
      }, "确 定")])]),
      default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_checkbox, {
        indeterminate: _ctx.data.basecheckAll ? !_ctx.data.baseisIndeterminate : _ctx.data.baseisIndeterminate,
        modelValue: _ctx.data.basecheckAll,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.data.basecheckAll = $event),
        onChange: _ctx.basehandleCheckAllChange
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [_createElementVNode("span", {
          style: {
            "font-weight": "bolder",
            "font-size": "14px"
          }
        }, "基础字段", -1)])),
        _: 1,
        __: [10]
      }, 8, ["indeterminate", "modelValue", "onChange"]), _createVNode(_component_el_checkbox_group, {
        modelValue: _ctx.data.basekeychecks,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.data.basekeychecks = $event),
        onChange: _ctx.basehandleCheckedCitiesChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.baseKeys, item => {
          return _openBlock(), _createBlock(_component_el_checkbox, {
            label: item.name,
            key: item.key,
            style: {
              "width": "135px"
            }
          }, null, 8, ["label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_checkbox, {
        indeterminate: _ctx.data.naturecheckAll ? !_ctx.data.natureisIndeterminate : _ctx.data.naturecheckAll,
        modelValue: _ctx.data.naturecheckAll,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.data.naturecheckAll = $event),
        onChange: _ctx.naturehandleCheckAllChange
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [_createElementVNode("span", {
          style: {
            "font-weight": "bolder",
            "font-size": "14px"
          }
        }, "属性字段", -1)])),
        _: 1,
        __: [11]
      }, 8, ["indeterminate", "modelValue", "onChange"]), _createVNode(_component_el_checkbox_group, {
        modelValue: _ctx.data.naturekeychecks,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.data.naturekeychecks = $event),
        onChange: _ctx.naturehandleCheckedCitiesChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.natureKeys, item => {
          return _openBlock(), _createBlock(_component_el_checkbox, {
            label: item.name,
            key: item.key,
            style: {
              "width": "135px"
            }
          }, null, 8, ["label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "onChange"])])]),
      _: 1
    }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_dialog, {
      modelValue: _ctx.data.isShowNotice,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.data.isShowNotice = $event),
      "close-on-click-modal": false,
      "destroy-on-close": "",
      "append-to-body": false,
      width: "30%",
      title: "通知下单",
      center: ""
    }, {
      footer: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.makeSureNotice
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("确定")])),
        _: 1,
        __: [13]
      }, 8, ["onClick"])])]),
      default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_table, {
        data: _ctx.data.noticeTableData,
        border: "",
        "header-row-class-name": "xthead",
        class: "xttb",
        onSelectionChange: _ctx.handleSelectionChange,
        ref: "multipleTable",
        onSelectAll: _ctx.selectAllChange,
        onSelect: _ctx.tableSelect
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          width: "55",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "depart",
          label: "下单部门",
          width: "180"
        }), _createVNode(_component_el_table_column, null, {
          header: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_icon, {
            size: 20,
            color: "#909399"
          }, {
            default: _withCtx(() => [_createVNode(_component_edit)]),
            _: 1
          }), _cache[12] || (_cache[12] = _createTextVNode("负责人 "))])]),
          default: _withCtx(scope => [_createElementVNode("div", {
            onClick: $event => _ctx.getRowCol(scope.row, scope.column, scope.$index),
            class: "selectdiv"
          }, [scope.row.islMainUserIdShow ? (_openBlock(), _createBlock(_component_el_select, {
            key: 0,
            modelValue: scope.row.user_id,
            "onUpdate:modelValue": $event => scope.row.user_id = $event,
            placeholder: "请选择",
            filterable: "",
            remote: "",
            "remote-method": _ctx.remoteMethod
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.userlist, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.nickname,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "remote-method"])) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.fullName(scope.row.user_id)), 1))], 8, _hoisted_7)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "onSelectionChange", "onSelectAll", "onSelect"])])]),
      _: 1
    }, 8, ["modelValue"])])])]),
    _: 1
  });
}